import dayjs from 'dayjs'
import timezonePlugin from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezonePlugin)

export const getScheduledTimeLabel = (
  scheduledAt?: number | null,
  timezone?: string,
): string | null => {
  if (!scheduledAt) return null

  const scheduledTime = dayjs.unix(scheduledAt)

  return (timezone ? scheduledTime.tz(timezone) : scheduledTime.utc()).format(
    'H[h]',
  )
}
